module.exports = __webpack_public_path__ + "static/hero-team-6ed6fae2d4bdfa99a6de44bed3c5de6c.svg";